export const usaUnemploymentAndGdp = [
  { date: new Date('1997-01-01'), unemploymentRate: 5.3, gdpPerCapita: 30778.0 },
  { date: new Date('1997-04-01'), unemploymentRate: 5.1, gdpPerCapita: 31263.0 },
  { date: new Date('1997-07-01'), unemploymentRate: 4.9, gdpPerCapita: 31687.0 },
  { date: new Date('1997-10-01'), unemploymentRate: 4.7, gdpPerCapita: 31964.0 },
  { date: new Date('1998-01-01'), unemploymentRate: 4.6, gdpPerCapita: 32248.0 },
  { date: new Date('1998-04-01'), unemploymentRate: 4.3, gdpPerCapita: 32534.0 },
  { date: new Date('1998-07-01'), unemploymentRate: 4.5, gdpPerCapita: 32980.0 },
  { date: new Date('1998-10-01'), unemploymentRate: 4.5, gdpPerCapita: 33504.0 },
  { date: new Date('1999-01-01'), unemploymentRate: 4.3, gdpPerCapita: 33842.0 },
  { date: new Date('1999-04-01'), unemploymentRate: 4.3, gdpPerCapita: 34161.0 },
  { date: new Date('1999-07-01'), unemploymentRate: 4.3, gdpPerCapita: 34626.0 },
  { date: new Date('1999-10-01'), unemploymentRate: 4.1, gdpPerCapita: 35283.0 },
  { date: new Date('2000-01-01'), unemploymentRate: 4, gdpPerCapita: 35556.0 },
  { date: new Date('2000-04-01'), unemploymentRate: 3.8, gdpPerCapita: 36339.0 },
  { date: new Date('2000-07-01'), unemploymentRate: 4, gdpPerCapita: 36490.0 },
  { date: new Date('2000-10-01'), unemploymentRate: 3.9, gdpPerCapita: 36808.0 },
  { date: new Date('2001-01-01'), unemploymentRate: 4.2, gdpPerCapita: 36845.0 },
  { date: new Date('2001-04-01'), unemploymentRate: 4.4, gdpPerCapita: 37211.0 },
  { date: new Date('2001-07-01'), unemploymentRate: 4.6, gdpPerCapita: 37110.0 },
  { date: new Date('2001-10-01'), unemploymentRate: 5.3, gdpPerCapita: 37234.0 },
  { date: new Date('2002-01-01'), unemploymentRate: 5.7, gdpPerCapita: 37582.0 },
  { date: new Date('2002-04-01'), unemploymentRate: 5.9, gdpPerCapita: 37860.0 },
  { date: new Date('2002-07-01'), unemploymentRate: 5.8, gdpPerCapita: 38099.0 },
  { date: new Date('2002-10-01'), unemploymentRate: 5.7, gdpPerCapita: 38274.0 },
  { date: new Date('2003-01-01'), unemploymentRate: 5.8, gdpPerCapita: 38584.0 },
  { date: new Date('2003-04-01'), unemploymentRate: 6, gdpPerCapita: 38976.0 },
  { date: new Date('2003-07-01'), unemploymentRate: 6.2, gdpPerCapita: 39752.0 },
  { date: new Date('2003-10-01'), unemploymentRate: 6, gdpPerCapita: 40362.0 },
  { date: new Date('2004-01-01'), unemploymentRate: 5.7, gdpPerCapita: 40801.0 },
  { date: new Date('2004-04-01'), unemploymentRate: 5.6, gdpPerCapita: 41358.0 },
  { date: new Date('2004-07-01'), unemploymentRate: 5.5, gdpPerCapita: 41911.0 },
  { date: new Date('2004-10-01'), unemploymentRate: 5.5, gdpPerCapita: 42561.0 },
  { date: new Date('2005-01-01'), unemploymentRate: 5.3, gdpPerCapita: 43285.0 },
  { date: new Date('2005-04-01'), unemploymentRate: 5.2, gdpPerCapita: 43718.0 },
  { date: new Date('2005-07-01'), unemploymentRate: 5, gdpPerCapita: 44350.0 },
  { date: new Date('2005-10-01'), unemploymentRate: 5, gdpPerCapita: 44850.0 },
  { date: new Date('2006-01-01'), unemploymentRate: 4.7, gdpPerCapita: 45675.0 },
  { date: new Date('2006-04-01'), unemploymentRate: 4.7, gdpPerCapita: 46089.0 },
  { date: new Date('2006-07-01'), unemploymentRate: 4.7, gdpPerCapita: 46361.0 },
  { date: new Date('2006-10-01'), unemploymentRate: 4.4, gdpPerCapita: 46807.0 },
  { date: new Date('2007-01-01'), unemploymentRate: 4.6, gdpPerCapita: 47289.0 },
  { date: new Date('2007-04-01'), unemploymentRate: 4.5, gdpPerCapita: 47802.0 },
  { date: new Date('2007-07-01'), unemploymentRate: 4.7, gdpPerCapita: 48216.0 },
  { date: new Date('2007-10-01'), unemploymentRate: 4.7, gdpPerCapita: 48592.0 },
  { date: new Date('2008-01-01'), unemploymentRate: 5, gdpPerCapita: 48457.0 },
  { date: new Date('2008-04-01'), unemploymentRate: 5, gdpPerCapita: 48875.0 },
  { date: new Date('2008-07-01'), unemploymentRate: 5.8, gdpPerCapita: 48865.0 },
  { date: new Date('2008-10-01'), unemploymentRate: 6.5, gdpPerCapita: 47799.0 },
  { date: new Date('2009-01-01'), unemploymentRate: 7.8, gdpPerCapita: 47123.0 },
  { date: new Date('2009-04-01'), unemploymentRate: 9, gdpPerCapita: 46865.0 },
  { date: new Date('2009-07-01'), unemploymentRate: 9.5, gdpPerCapita: 46977.0 },
  { date: new Date('2009-10-01'), unemploymentRate: 10, gdpPerCapita: 47525.0 },
  { date: new Date('2010-01-01'), unemploymentRate: 9.8, gdpPerCapita: 47797.0 },
  { date: new Date('2010-04-01'), unemploymentRate: 9.9, gdpPerCapita: 48403.0 },
  { date: new Date('2010-07-01'), unemploymentRate: 9.4, gdpPerCapita: 48821.0 },
  { date: new Date('2010-10-01'), unemploymentRate: 9.4, gdpPerCapita: 49256.0 },
  { date: new Date('2011-01-01'), unemploymentRate: 9.1, gdpPerCapita: 49302.0 },
  { date: new Date('2011-04-01'), unemploymentRate: 9.1, gdpPerCapita: 49873.0 },
  { date: new Date('2011-07-01'), unemploymentRate: 9, gdpPerCapita: 50056.0 },
  { date: new Date('2011-10-01'), unemploymentRate: 8.8, gdpPerCapita: 50573.0 },
  { date: new Date('2012-01-01'), unemploymentRate: 8.3, gdpPerCapita: 51205.0 },
  { date: new Date('2012-04-01'), unemploymentRate: 8.2, gdpPerCapita: 51554.0 },
  { date: new Date('2012-07-01'), unemploymentRate: 8.2, gdpPerCapita: 51803.0 },
  { date: new Date('2012-10-01'), unemploymentRate: 7.8, gdpPerCapita: 52015.0 },
  { date: new Date('2013-01-01'), unemploymentRate: 8, gdpPerCapita: 52652.0 },
  { date: new Date('2013-04-01'), unemploymentRate: 7.6, gdpPerCapita: 52816.0 },
  { date: new Date('2013-07-01'), unemploymentRate: 7.3, gdpPerCapita: 53415.0 },
  { date: new Date('2013-10-01'), unemploymentRate: 7.2, gdpPerCapita: 54051.0 },
  { date: new Date('2014-01-01'), unemploymentRate: 6.6, gdpPerCapita: 53972.0 },
  { date: new Date('2014-04-01'), unemploymentRate: 6.2, gdpPerCapita: 54878.0 },
  { date: new Date('2014-07-01'), unemploymentRate: 6.2, gdpPerCapita: 55652.0 },
  { date: new Date('2014-10-01'), unemploymentRate: 5.7, gdpPerCapita: 55869.0 },
  { date: new Date('2015-01-01'), unemploymentRate: 5.7, gdpPerCapita: 56243.0 },
  { date: new Date('2015-04-01'), unemploymentRate: 5.4, gdpPerCapita: 56815.0 },
  { date: new Date('2015-07-01'), unemploymentRate: 5.2, gdpPerCapita: 57072.0 },
  { date: new Date('2015-10-01'), unemploymentRate: 5, gdpPerCapita: 57055.0 },
  { date: new Date('2016-01-01'), unemploymentRate: 4.8, gdpPerCapita: 57234.0 },
  { date: new Date('2016-04-01'), unemploymentRate: 5.1, gdpPerCapita: 57705.0 },
  { date: new Date('2016-07-01'), unemploymentRate: 4.8, gdpPerCapita: 58144.0 },
  { date: new Date('2016-10-01'), unemploymentRate: 4.9, gdpPerCapita: 58636.0 },
  { date: new Date('2017-01-01'), unemploymentRate: 4.7, gdpPerCapita: 59132.0 },
  { date: new Date('2017-04-01'), unemploymentRate: 4.4, gdpPerCapita: 59527.0 },
  { date: new Date('2017-07-01'), unemploymentRate: 4.3, gdpPerCapita: 60196.0 },
  { date: new Date('2017-10-01'), unemploymentRate: 4.2, gdpPerCapita: 61146.0 },
  { date: new Date('2018-01-01'), unemploymentRate: 4, gdpPerCapita: 61960.0 },
  { date: new Date('2018-04-01'), unemploymentRate: 4, gdpPerCapita: 62646.0 },
  { date: new Date('2018-07-01'), unemploymentRate: 3.8, gdpPerCapita: 63210.0 },
  { date: new Date('2018-10-01'), unemploymentRate: 3.8, gdpPerCapita: 63479.0 },
  { date: new Date('2019-01-01'), unemploymentRate: 4, gdpPerCapita: 64000.0 },
  { date: new Date('2019-04-01'), unemploymentRate: 3.7, gdpPerCapita: 64794.0 },
  { date: new Date('2019-07-01'), unemploymentRate: 3.7, gdpPerCapita: 65665.0 },
  { date: new Date('2019-10-01'), unemploymentRate: 3.6, gdpPerCapita: 66222.0 },
  { date: new Date('2020-01-01'), unemploymentRate: 3.6, gdpPerCapita: 65606.0 },
  { date: new Date('2020-04-01'), unemploymentRate: 14.8, gdpPerCapita: 60158.0 },
  { date: new Date('2020-07-01'), unemploymentRate: 10.2, gdpPerCapita: 65387.0 },
  { date: new Date('2020-10-01'), unemploymentRate: 6.9, gdpPerCapita: 66505.0 },
  { date: new Date('2021-01-01'), unemploymentRate: 6.4, gdpPerCapita: 68304.0 },
  { date: new Date('2021-04-01'), unemploymentRate: 6.1, gdpPerCapita: 70514.0 },
  { date: new Date('2021-07-01'), unemploymentRate: 5.4, gdpPerCapita: 72098.0 },
  { date: new Date('2021-10-01'), unemploymentRate: 4.5, gdpPerCapita: 74490.0 },
  { date: new Date('2022-01-01'), unemploymentRate: 4, gdpPerCapita: 75719.0 },
  { date: new Date('2022-04-01'), unemploymentRate: 3.7, gdpPerCapita: 77434.0 },
  { date: new Date('2022-07-01'), unemploymentRate: 3.5, gdpPerCapita: 78697.0 },
  { date: new Date('2022-10-01'), unemploymentRate: 3.6, gdpPerCapita: 79821.0 },
  { date: new Date('2023-01-01'), unemploymentRate: 3.5, gdpPerCapita: 80997.0 },
  { date: new Date('2023-04-01'), unemploymentRate: 3.4, gdpPerCapita: 81768.0 },
  { date: new Date('2023-07-01'), unemploymentRate: 3.5, gdpPerCapita: 83185.0 },
  { date: new Date('2023-10-01'), unemploymentRate: 3.9, gdpPerCapita: 84007.0 },
  { date: new Date('2024-01-01'), unemploymentRate: 3.7, gdpPerCapita: 84655.0 },
  { date: new Date('2024-04-01'), unemploymentRate: 3.9, gdpPerCapita: 85744.0 },
  { date: new Date('2024-07-01'), unemploymentRate: 4.2, gdpPerCapita: 86637.0 },
  { date: new Date('2024-10-01'), unemploymentRate: 4.1, gdpPerCapita: 87422.0 },
  { date: new Date('2025-01-01'), unemploymentRate: 4, gdpPerCapita: 87948.0 },
  { date: new Date('2025-04-01'), unemploymentRate: 4.2, gdpPerCapita: 89131.0 },
];
